import {
	createRouter,
	createWebHashHistory
} from 'vue-router'
// import Home from '../views/Home.vue'
import Test from '../components/test/Test.vue'
import PageNotFound from '../components/404/404.vue'
import Login from '../components/login/Login.vue'
import Home from '../components/home/Home.vue'
import Main from '../components/main/Main.vue'
import AdminList from '../components/admin/AdminList'
import AdminEdit from '../components/admin/AdminEdit'
import Account from '../components/admin/Account.vue'
import Category from '../components/category/Category'
import RoleList from '../components/role/RoleList'
import RoleEdit from '../components/role/RoleEdit'
import MenuList from '../components/menu/MenuList'
import MenuEdit from '../components/menu/MenuEdit'
import ProductList from '../components/product/ProductList.vue'
import ProductEdit from '../components/product/ProductEdit.vue'
import ProductType from '../components/product/ProductType.vue'
import ProductSpec from '../components/product/ProductSpec.vue'
import Mail from '../components/mail/Mail.vue'
import OrderList from '../components/order/OrderList.vue'
import OrderInfo from '../components/order/OrderInfo.vue'
import SwiperList from '../components/swiper/SwiperList.vue'
import PosterList from '../components/poster/PosterList.vue'
import AppointmentList from '../components/appointment/Appointmentlist.vue'
import HomeProductRecommend from '../components/homeproductrecommend/HomeProductRecommend.vue'
import CustomerList from '../components/customer/CustomerList.vue'
import ProductSizeType from '../components/product/ProductSizeType.vue'
import ProductSaleType from '../components/product/ProductSaleType.vue'
import VipGrade from '../components/vipgrade/VipGrade.vue'
import VipGradeSet from '../components/vipgrade/VipGradeSet.vue'
import CustomerPoint from '../components/customerpoint/CustomerPoint.vue'
import ProductSetShipping from '../components/product/ProductSetShipping.vue'
import OrderMap from '../components/analysis/OrderMap.vue'
import ProductViewRank from '../components/analysis/ProductViewRank.vue'
import CategoryPromotion from '../components/promotion/CategoryPromotion.vue'
import FullReduction from '../components/fullreduction/FullReduction.vue'
import PanicPromotion from '../components/promotion/PanicPromotion.vue'
import CategoryFreeShipping from '../components/promotion/CategoryFreeShipping.vue'
import BirthGuideList from '../components/birthguide/BirthGuideList.vue'
import StoreManagerLog from '../components/store_manager_log/StoreManagerLog.vue'
import PointMutiPromotion from '../components/promotion/PointMutiPromotion.vue'
import WigList from '../components/Wig/WigList.vue'
import BlogList from '../components/blog/BlogList.vue'
import CouponList from '../components/promotion/CouponPromotion.vue'
import RakutenHomeFirst from '../components/rakuten/RakutenHomeFirst.vue'
import RakutenHomeRotation from '../components/rakuten/RakutenHomeRotation.vue'
import RakutenHomeHotCloth from '../components/rakuten/RakutenHomeHotCloth.vue'
import RakutenHomeSeriesCloth from '../components/rakuten/RakutenHomeSeriesCloth.vue'
import RakutenHomeHotSeriesCloth from '../components/rakuten/RakutenHomeHotSeriesCloth.vue'
import RakutenOrderApi from '../components/rakuten/RakutenOrderApi.vue'
import CosonsenHomeMobileBanner from '../components/cosonsen/CosonsenHomeMobileBanner.vue'
import chatCompletionsModel from '../components/chatgpt/chatCompletionsModel.vue'
import LotteryList from '../components/lottery/lottery_list.vue'
import ProductSetOmShipping from '../components/product/ProductSetOmShipping.vue'
import ProductSetDeliveryExpressTemplate from '../components/product/ProductSetDeliveryExpressTemplate.vue'
import ProductSetCountryTemplate from '../components/product/ProductSetCountryTemplate.vue'
const routes = [{
		path: '/',
		name: 'Page',
		redirect: {
			name: 'Home'
		}
	},
	{
		path: "/:catchAll(.*)",
		redirect: {
			name: 'PageNotFound'
		}
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	{
		path: '/test',
		name: 'Test',
		component: Test
	},
	{
		path: '/main',
		name: 'Main',
		component: Main,
		children: [{
				path: '404',
				name: 'PageNotFound',
				component: PageNotFound
			},
			{
				path: 'home',
				name: 'Home',
				component: Home,
				meta: {
					title: '首页'
				}
			},
			{
				path: 'admin_list',
				name: 'AdminList',
				component: AdminList
			},
			{
				path: 'admin_edit',
				name: 'AdminEdit',
				component: AdminEdit
			},
			{
				path: 'account',
				name: 'Account',
				component: Account
			},
			{
				path: 'role_list',
				name: 'RoleList',
				component: RoleList
			},
			{
				path: 'role_edit',
				name: 'RoleEdit',
				component: RoleEdit
			},
			{
				path: 'menu_list',
				name: 'MenuList',
				component: MenuList
			},
			{
				path: 'menu_edit',
				name: 'MenuEdit',
				component: MenuEdit
			},
			{
				path: 'category',
				name: 'Category',
				component: Category
			},
			{
				path: 'product_list',
				name: 'ProductList',
				component: ProductList
			},
			{
				path: 'product_edit',
				name: 'ProductEdit',
				component: ProductEdit
			},
			{
				path: 'productType',
				name: 'ProductType',
				component: ProductType

			},
			{
				path: 'ProductSpec',
				name: 'ProductSpec',
				component: ProductSpec
			},
			{
				path: 'ProductSizeType',
				name: 'ProductSizeType',
				component: ProductSizeType
			},
			{
				path: 'ProductSaleType',
				name: 'ProductSaleType',
				component: ProductSaleType
			},
			{
				path: 'ProductSetShipping',
				name: 'ProductSetShipping',
				component: ProductSetShipping
			},
			{
				path: 'mail',
				name: 'Mail',
				component: Mail
			},
			{
				path: 'order_list',
				name: 'OrderList',
				component: OrderList
			},
			{
				path: 'order_info',
				name: 'OrderInfo',
				component: OrderInfo
			},
			{
				path: 'swiper_list',
				name: 'SwiperList',
				component: SwiperList
			},
			{
				path: 'poster_list',
				name: 'PosterList',
				component: PosterList
			},
			{
				path: 'appointment_list',
				name: 'AppointmentList',
				component: AppointmentList
			},
			{
				path: 'wig_list',
				name: 'WigList',
				component: WigList
			},
			{
				path: 'customer_list',
				name: 'CustomerList',
				component: CustomerList
			},
			{
				path: 'vip_grade',
				name: 'VipGrade',
				component: VipGrade
			},
			{
				path: 'vip_grade_set',
				name: 'VipGradeSet',
				component: VipGradeSet
			},
			{
				path: 'customer_point',
				name: 'CustomerPoint',
				component: CustomerPoint
			},
			{
				path: 'OrderMap',
				name: 'OrderMap',
				component: OrderMap

			},
			{
				path: 'ProductViewRank',
				name: 'ProductViewRank',
				component: ProductViewRank
			},
			{
				path: 'CategoryPromotion',
				name: 'CategoryPromotion',
				component: CategoryPromotion
			},
			{
				path: 'PanicPromotion',
				name: 'PanicPromotion',
				component: PanicPromotion
			},
			{
				path: 'CategoryFreeShipping',
				name: 'CategoryFreeShipping',
				component: CategoryFreeShipping
			},
			{
				path: 'PointMutiPromotion',
				name: 'PointMutiPromotion',
				component: PointMutiPromotion,
				meta: {
					title: '积分多倍促销'
				}
			},
			{
				path: 'full_reduction',
				name: 'FullReduction',
				component: FullReduction
			},
			{
				path: 'birthguide_list',
				name: 'BirthGuideList',
				component: BirthGuideList
			},
			{
				path: 'homeproductrecommend_list',
				name: 'HomeProductRecommend',
				component: HomeProductRecommend
			},
			{
				path: 'store_manager_log',
				name: 'StoreManagerLog',
				component: StoreManagerLog
			},
			{
				path: 'blog_list',
				name: 'BlogList',
				component: BlogList
			},
			{
				path: "coupon_list",
				name: 'CouponList',
				component: CouponList
			},
			{
				path: 'rakuten_home_first',
				name: 'RakutenHomeFirst',
				component: RakutenHomeFirst
			},
			{
				path: 'Rakuten_home_rotation',
				name: 'RakutenHomeRotation',
				component: RakutenHomeRotation
			},
			{

				path: 'rakuten_home_hot_cloth',
				name: 'RakutenHomeHotCloth',
				component: RakutenHomeHotCloth
			},
			{
				path: 'rakuten_home_series_cloth',
				name: 'RakutenHomeSeriesCloth',
				component: RakutenHomeSeriesCloth
			},
			{
				path: 'rakuten_home_hot_series_cloth',
				name: 'RakutenHomeHotSeriesCloth',
				component: RakutenHomeHotSeriesCloth
			},
			{
				path: 'rakuten_order_api',
				name: 'RakutenOrderApi',
				component: RakutenOrderApi
			},
			{
				path: 'cosonsen_mobile_banner',
				name: 'CosonsenHomeMobileBanner',
				component: CosonsenHomeMobileBanner
			},
			{
				path: 'chatCompletionsModel',
				name: 'chatCompletionsModel',
				component:chatCompletionsModel
			},
			{
				path: 'Lottery_list',
				name: 'LotteryList',
				component:LotteryList
			},
			{
				path: 'ProductSetOmShipping',
				name: 'ProductSetOmShipping',
				component:ProductSetOmShipping
			},
			{
				path: 'ProductSetDeliveryExpressTemplate',
				name: 'ProductSetDeliveryExpressTemplate',
				component:ProductSetDeliveryExpressTemplate
			},
			{
				path: 'ProductSetCountryTemplate',
				name: 'ProductSetCountryTemplate',
				component:ProductSetCountryTemplate
			}
		]
	},

]

const router = createRouter({
	// history: createWebHistory(process.env.BASE_URL),
	history: createWebHashHistory(),
	routes
})

export default router
